export default __webpack_public_path__ + "static/media/22_desktop.fe443478.jpg";